import PropTypes from 'prop-types';
import React from 'react';

const FeatureFlagSwitcher = ({ user, isOn, isOff, featureFlagCheck, ...rest }) => {
  let Component = isOff;
  if (featureFlagCheck()) Component = isOn;
  return <Component user={user} {...rest} />;
};

FeatureFlagSwitcher.propTypes = {
  user: PropTypes.object,
  isOn: PropTypes.any,
  isOff: PropTypes.any,
  featureFlagCheck: PropTypes.func.isRequired,
};

export default FeatureFlagSwitcher;
